import { cloneDeep } from 'lodash';
import { GetterTree, ActionTree, MutationTree, ActionContext } from 'vuex';

interface LoadingState {
  loadingQueue: boolean[];
}

export const defaultLoaderState: LoadingState = {
  loadingQueue: []
};

const state: LoadingState = cloneDeep(defaultLoaderState);

const mutations: MutationTree<LoadingState> = {
  ADD_TO_QUEUE(returnedState: LoadingState): void {
    returnedState.loadingQueue.push(true);
  },
  REMOVE_FROM_QUEUE(returnedState: LoadingState): void {
    if (returnedState.loadingQueue.length && typeof returnedState.loadingQueue[0] === 'boolean') {
      returnedState.loadingQueue.shift();
    }
  }
};

const actions: ActionTree<LoadingState, {}> = {
  addToQueue: ({ commit }: ActionContext<LoadingState, {}>): void => {
    commit('ADD_TO_QUEUE');
  },
  removeFromQueue: ({ commit }: ActionContext<LoadingState, {}>): void => {
    commit('REMOVE_FROM_QUEUE');
  }
};

const getters: GetterTree<LoadingState, {}> = {
  isLoading: (returnedState: LoadingState): boolean => {
    return Boolean(returnedState.loadingQueue.length);
  },
  queue: (returnedState: LoadingState): boolean[] => {
    return returnedState.loadingQueue;
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
